import { render, staticRenderFns } from "./BulkImportResult.vue?vue&type=template&id=7141a7c6&scoped=true"
import script from "./BulkImportResult.vue?vue&type=script&lang=js"
export * from "./BulkImportResult.vue?vue&type=script&lang=js"
import style0 from "./BulkImportResult.vue?vue&type=style&index=0&id=7141a7c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7141a7c6",
  null
  
)

export default component.exports